import React, { useEffect, useMemo, useRef, useState } from "react";
import { IPoolsProps } from "./Pools.props";
import { useIntl } from "react-intl";

import styles from "./Pools.module.scss";
import { Input, InputRef, Segmented } from "antd";
import Status from "../../Status/Status";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import Copy from "../../Copy/Copy";

export default function Pools(props: IPoolsProps) {
  const { formatMessage } = useIntl();
  const inputAddressRef = useRef<InputRef | null>(null);
  const [segment, setSegment] = useState<0 | 1 | 2>(0);

  const currentPool = useMemo(() => {
    return props.pools[segment];
  }, [segment, props.pools]);

  const ext = useMemo(() => {
    if (!currentPool) return "";

    const v = JSON.parse(currentPool.props || "{}")?.extension;

    return v ? "#" + v : "";
  }, [currentPool]);

  useEffect(() => {
    inputAddressRef.current?.setSelectionRange(0, 400);
    inputAddressRef.current?.focus({ preventScroll: true });
  }, [inputAddressRef.current]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.segment_wrapper}>
        <Segmented
          className={styles.selector}
          options={props.pools.map((p, i) => ({
            label: (
              <Status status={(p.status === 1 ? 0 : 8) as MINER_STATUSES_E} />
            ),
            value: i,
          }))}
          onChange={(v) => setSegment(v as typeof segment)}
        />
      </div>
      <div className={styles.pools_wrapper}>
        <div className={styles.pool}>
          <p className={styles.title}>
            {formatMessage({ id: `settings.option.${segment + 1}` })}
          </p>
          <div className={styles.input} title={currentPool.address + ext}>
            <Input
              addonBefore={formatMessage({
                id: "settings.option.address",
              })}
              value={currentPool.address + ext}
              size='small'
              ref={inputAddressRef}
              onLoad={(e) => e.currentTarget.setSelectionRange(0, 400)}
              onFocus={(e) => {
                e.preventDefault();
                e.stopPropagation();
                e.target.setSelectionRange(0, 400);
              }}
              readOnly
            />
            <Copy text={currentPool.address + ext} />
          </div>
          <div className={styles.input} title={currentPool.login}>
            <Input
              addonBefore={formatMessage({
                id: "settings.option.login",
              })}
              value={currentPool.login}
              size='small'
              readOnly
            />
            <Copy text={currentPool.login} />
          </div>{" "}
          <div className={styles.input} title={currentPool.password}>
            <Input
              addonBefore={formatMessage({
                id: "settings.option.password",
              })}
              value={currentPool.password}
              size='small'
              readOnly
            />
            <Copy text={currentPool.password} />
          </div>
        </div>
      </div>
    </div>
  );
}
